import {useEffect} from 'react';
import log from 'loglevel';

import LargeCard from './large-card';

const statsGroup = props => {
  return(
    <div className="tight-grid"><div className="container">
      {props.stats.map((item, i) =>
        <LargeCard key={i} {...item} />
      )}
    </div></div>
  )
};

export default React.memo(statsGroup);
